import React, { useMemo } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./IndustryDensity.css";

const INDUSTRY_TOOLTIP =
  "Industry Density shows the percentage split of the industries associated with this resume.";

const BAR_COLORS = ["#2F5BFF", "#0D4B5E", "#1FA34A", "#F59E0B"];

const getIndustryName = (item) => item?.IndustryName || item?.industryName || "Industry not added";
const getIndustryPercent = (item) => {
  const rawValue = item?.IndustryPercent ?? item?.Percentage ?? item?.percent ?? 0;
  return Number(rawValue) || 0;
};

const normalizeItems = (data) =>
  Array.isArray(data)
    ? data
        .map((item, index) => ({
          index,
          name: getIndustryName(item),
          percent: getIndustryPercent(item),
        }))
        .filter((item) => item.name)
        .sort((a, b) => b.percent - a.percent || a.index - b.index)
    : [];

const IndustryDensity = ({ data = [] }) => {
  const items = useMemo(() => normalizeItems(data), [data]);

  if (!items.length) return null;

  return (
    <section className="industryDensityCard" aria-label="Industry Density">
      <div className="industryDensityHeader">
        <div className="industryDensityHeadingGroup">
          <h3>Industry Density</h3>
          <Tooltip placement="top" title={INDUSTRY_TOOLTIP} color="#3b3b3b">
            <button type="button" className="industryDensityInfoButton" aria-label="Industry Density information">
              <InfoCircleOutlined />
            </button>
          </Tooltip>
        </div>
      </div>

      <div className="industryDensityPanel">
        <div className="industryDensityBarList">
          {items.slice(0, 4).map((item, index) => (
            <div className="industryDensityBarRow" key={`${item.name}-${item.index}`}>
              <div className="industryDensityBarLabel" title={item.name}>
                {item.name}
              </div>
              <div className="industryDensityBarTrack" aria-hidden="true">
                <div
                  className="industryDensityBarFill"
                  style={{
                    width: `${Math.max(0, Math.min(100, item.percent))}%`,
                    "--industry-density-bar-color": BAR_COLORS[index % BAR_COLORS.length],
                  }}
                />
              </div>
              <div className="industryDensityBarPercent">{item.percent}%</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryDensity;
